var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01562 5.29688C4.3943 5.29688 3.89062 5.80055 3.89062 6.42188V17.6719C3.89062 18.2932 4.3943 18.7969 5.01562 18.7969H20.7656C21.3869 18.7969 21.8906 18.2932 21.8906 17.6719V6.42188C21.8906 5.80055 21.3869 5.29688 20.7656 5.29688H5.01562ZM2.39062 6.42188C2.39062 4.97213 3.56588 3.79688 5.01562 3.79688H20.7656C22.2154 3.79688 23.3906 4.97213 23.3906 6.42188V17.6719C23.3906 19.1216 22.2154 20.2969 20.7656 20.2969H5.01562C3.56588 20.2969 2.39062 19.1216 2.39062 17.6719V6.42188Z",
    fill: "#146C94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54865 7.08645C5.80295 6.75949 6.27415 6.70059 6.60111 6.9549L12.8907 11.8468L19.1802 6.9549C19.5072 6.70059 19.9784 6.75949 20.2327 7.08645C20.487 7.41341 20.4281 7.88462 20.1011 8.13892L13.3511 13.3889C13.0803 13.5996 12.701 13.5996 12.4302 13.3889L5.6802 8.13892C5.35324 7.88462 5.29434 7.41341 5.54865 7.08645Z",
    fill: "#146C94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailblue);
export default __webpack_public_path__ + "static/media/emailblue.7b849012a978712f257ee794f56a99c1.svg";
export { ForwardRef as ReactComponent };